import { morphdomMorphTemplate } from "web-ui/morphdom/morph-template"
import { isMorphdomIgnored } from "web-ui/morphdom/ignore"
import * as Log from "web-ui/log"

function isFocused(element) {
  const isInput = ["INPUT", "SELECT", "TEXTAREA"].includes(element.tagName)
  if (!isInput) {
    return false
  }

  return document.hasFocus() && element === document.activeElement
}

function isTemplate(element) {
  return element.tagName === "TEMPLATE"
}

export function morphdomShouldUpdate(fromElement, toElement) {
  if (isTemplate(fromElement)) {
    morphdomMorphTemplate(fromElement, toElement)
    return false
  }

  // Do not update anything that has focus, unless the toElement is disabled
  // - Aaron, Wed Aug 09 2023
  if (isFocused(fromElement) && !toElement.disabled) {
    return false
  }

  // Do not update elements that indicate they should be ignored
  if (isMorphdomIgnored(fromElement)) {
    Log.debug("Morphdom - Update skipped for ignored element", { id: fromElement.id })

    return false
  }

  return true
}
